import { useContext } from 'react';

import { Anchor, Box, Text } from '@zillow/constellation-10';

import { RMWContext } from '../../providers/RMWContext';

import type { ReactNode } from 'react';

type Props = {
  actionText: string;
  isTextCenter?: boolean;
  isNotFlatFee?: boolean;
  displayPrice?: string;
  useFreemiumValues?: boolean;
  previewListingCTA?: ReactNode;
};

const ListingActivationTerms = ({
  actionText,
  isTextCenter = false,
  isNotFlatFee = false,
  displayPrice = '',
  useFreemiumValues = false,
  previewListingCTA,
}: Props) => {
  const { paths } = useContext(RMWContext);

  const renderBaseContent = () => {
    return (
      <>
        {actionText}, you agree to comply with our&nbsp;
        <Anchor href={paths.corpTermsURL} target="_blank">
          Terms of Use
        </Anchor>
        ,&nbsp;
        <Anchor href={paths.rentalTermsURL} target="_blank">
          Rental User Terms
        </Anchor>
        , and&nbsp;
        <Anchor href={paths.pledgeURL} target="_blank">
          Respectful Renting Pledge
        </Anchor>
        .
      </>
    );
  };

  const renderLegacyContent = () => {
    return (
      <>
        {isNotFlatFee ? (
          <>
            {actionText}, you agree you are purchasing a continuous subscription and will be charged&nbsp;
            {displayPrice}
            &nbsp;until you cancel and to comply with our&nbsp;
            <Anchor href={paths.pledgeURL} target="_blank">
              Respectful Renting Pledge
            </Anchor>
            . Cancel anytime by deactivating your listing. For more information see our&nbsp;
            <Anchor href={paths.corpTermsURL} target="_blank">
              Terms of Use
            </Anchor>
            &nbsp;and&nbsp;
            <Anchor href={paths.rentalTermsURL} target="_blank">
              Rental User Terms
            </Anchor>
            .
          </>
        ) : (
          renderBaseContent()
        )}
      </>
    );
  };

  if (previewListingCTA) {
    return (
      <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text textStyle="fineprint">{useFreemiumValues ? renderBaseContent() : renderLegacyContent()}</Text>

        {previewListingCTA}
      </Box>
    );
  }

  return (
    <Box
      data-testid="listing-activation-terms"
      className="fs-unmask"
      css={{ textAlign: isTextCenter ? 'center' : 'left' }}
    >
      <Text textStyle="fineprint">{useFreemiumValues ? renderBaseContent() : renderLegacyContent()}</Text>
    </Box>
  );
};

export default ListingActivationTerms;
